import { Button, Grid, Skeleton, Typography, Box } from "@mui/material";
import { getDogs } from "../services";
import { useWpFetch } from "../hooks/useWpFetch";
import { Link, useLocation, useNavigate } from "react-router";
import { DogCard } from "../components/DogCard/DogCard";
import { getCategoryFromQuery } from "../utils/getCategoryFromQuery";

const Dogs = () => {
  const { data: dogs, loading } = useWpFetch(() => getDogs(), [], []);
  const location = useLocation();
  const navigate = useNavigate();
  const category = getCategoryFromQuery(location);

  const setCategory = (cat: "female" | "male") => {
    const params = new URLSearchParams(location.search);
    params.set("category", cat);
    navigate({ search: params.toString() }, { replace: true });
  };
  return (
    <Box className="article-main">
      <Typography
        variant="h4"
        sx={{
          fontFamily: '"Cinzel", serif',
          color: "#4a3728",
          borderBottom: "2px solid #d4b483",
          pb: 1,
          mb: 3,
        }}
      >
        Our Dogs
      </Typography>
      <Box sx={{ mb: 3 }}>
        <Button
          variant={category === "female" ? "contained" : "outlined"}
          onClick={() => setCategory("female")}
          sx={{
            mr: 2,
            backgroundColor: category === "female" ? "#b68a58" : "transparent",
            borderColor: "#b68a58",
            color: category === "female" ? "#fff" : "#b68a58",
            "&:hover": {
              backgroundColor:
                category === "female" ? "#9a7348" : "rgba(182,138,88,0.1)",
              borderColor: "#b68a58",
            },
          }}
        >
          Females
        </Button>
        <Button
          variant={category === "male" ? "contained" : "outlined"}
          onClick={() => setCategory("male")}
          sx={{
            backgroundColor: category === "male" ? "#b68a58" : "transparent",
            borderColor: "#b68a58",
            color: category === "male" ? "#fff" : "#b68a58",
            "&:hover": {
              backgroundColor:
                category === "male" ? "#9a7348" : "rgba(182,138,88,0.1)",
              borderColor: "#b68a58",
            },
          }}
        >
          Males
        </Button>
      </Box>
      <Grid container spacing={3}>
        {loading
          ? [1, 2, 3].map((i) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={i}>
                <Skeleton
                  variant="rectangular"
                  height={220}
                  sx={{ borderRadius: 2, mb: 1 }}
                />
                <Skeleton variant="text" width="60%" height={28} />
                <Skeleton variant="text" width="80%" />
              </Grid>
            ))
          : dogs
              .filter((dog: any) => dog?.sex === category)
              .map((dog: any) => {
                return (
                  <Grid size={{ xs: 12, sm: 6, md: 4 }} key={dog.id}>
                    <Link
                      to={`/dogs/${dog.id}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <DogCard
                        src={dog.image || ""}
                        title={dog.name || "Dog"}
                      />
                    </Link>
                  </Grid>
                );
              })}
      </Grid>
    </Box>
  );
};

export default Dogs;
